<template>
    <div class="category-card">
        <h3>{{ t(`resources.categories.${category}`) }}</h3>
        <p class="subtitle">{{ t(`resources.categories.${category}.subtitle`) }}</p>
        <UncrawlableLink v-slot="{navigate}" custom :to="$withLocalePrefix(`/resources/search?category=${category}`)" external>
            <VJoyIconButton label="''" variant="secondary" size="xsmall" icon="arrow-right" class="button" @click="navigate" />
        </UncrawlableLink>
    </div>
</template>

<script lang="ts" setup>
    import {UncrawlableLink} from '#components';
    import {useTranslation} from '#imports';
    import {VJoyIconButton} from '@maltjoy/core-vue';
    import type {TranslationKeyPart} from '#build/i18n';

    defineProps<{category: TranslationKeyPart<'resources.categories.*.subtitle'>}>();
    const {t} = useTranslation();
</script>

<style lang="scss">
    @use '~/assets/styles/variables' as *;

    .category-card {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        h3 {
            font-size: 40px;
            line-height: 97%;
            font-weight: 800;
            margin-bottom: var(--joy-core-spacing-2);

            @media (max-width: $tablet-breakpoint) {
                font-size: 30px;
                margin-bottom: var(--joy-core-spacing-4);
            }
        }

        .subtitle {
            margin-bottom: var(--joy-core-spacing-9);
            color: var(--joy-color-neutral-40);

            @media (max-width: $tablet-breakpoint) {
                margin-bottom: var(--joy-core-spacing-5);
            }
        }

        .button {
            --button-color-secondary: var(--joy-color-primary-50);
            --button-bg-color-secondary-hover: var(--joy-color-primary-10);

            padding: 0 8px;

            joy-icon {
                margin-right: 0 !important;
            }
        }
    }
</style>
